import type { Injector } from '@angular/core';
import { OnyxPhonePipe } from '@onyx/angular';
import { Duration } from 'luxon';
import type { z } from 'zod';
import type { PointOfInterest } from '../interfaces/point-of-interest';
import type { getPointsOfInterestXlsxSchema } from './points-of-interest-xlsx-schema';

export type PointOfInterestExportData = z.input<
  ReturnType<typeof getPointsOfInterestXlsxSchema>
>;

export const getPointsOfInterestExportData = (
  pointOfInterest: PointOfInterest,
  injector: Injector,
): PointOfInterestExportData => {
  const phonePipe = injector.get(OnyxPhonePipe);

  const {
    name,
    address,
    businessHours,
    time: { averageServiceTime },
    phone,
    note,
    contractors,
  } = pointOfInterest;

  const formatTime = (time?: string) => time?.slice(0, 5) ?? '';

  return {
    /* pointInformation */
    address: address.label,
    name,

    /* businessHours */
    weekdayFrom: formatTime(businessHours.weekday.from),
    weekdayTo: formatTime(businessHours.weekday.to),
    saturdayFrom: formatTime(businessHours.saturday?.from),
    saturdayTo: formatTime(businessHours.saturday?.to),
    sundayFrom: formatTime(businessHours.sunday?.from),
    sundayTo: formatTime(businessHours.sunday?.to),

    /* times */
    averageServiceTime: Duration.fromObject({
      seconds: averageServiceTime,
    }).toFormat('hh:mm'),

    /* contact */
    phone: phone ? phonePipe.transform(phone) : null,

    /* contractors */
    contractors: contractors.length
      ? contractors.map((contractor) => contractor.contractor.uuid).join(', ')
      : null,

    /* note */
    note: note?.content ?? null,
  } satisfies PointOfInterestExportData;
};
